export default "__VITE_ASSET__COlvPaV3__"